module.exports = __webpack_public_path__ + "img/deepDive.7d56d556.png";